import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://www.maqlinesolutions.com";

function setMeta(selector, attr, value) {
  let el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

export function useSEO(title, description) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    const url = SITE_URL + (pathname === "/" ? "/" : pathname);
    setMeta('meta[property="og:url"]', "content", url);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;
  }, [title, description, pathname]);
}
